import { AxiosInstance } from 'axios';

export type RefreshTokenResponse = {
  data: {
    accessCode: string;
    expiresIn: number;
    tokenType: string;
    message: string;
  };
};

export class AuthServiceApi {
  constructor(private client: AxiosInstance) {}

  logout(): Promise<any> {
    return this.client.post('/api/auth/logout');
  }

  refreshToken(): Promise<RefreshTokenResponse> {
    return this.client
      .get<RefreshTokenResponse>('/api/auth/refresh-token')
      .then((response) => response.data);
  }
}
